export const primary: Record<string, string> = {
    black: "var(--formant-color-primary-black)",
    dark: "var(--formant-color-primary-dark)",
    dark02: "var(--formant-color-primary-dark02)",
    flagship: "var(--formant-color-primary-flagship)",
    module: "var(--formant-color-primary-module)",
    steel01: "var(--formant-color-primary-steel01)",
    steel02: "var(--formant-color-primary-steel02)",
    steel03: "var(--formant-color-primary-steel03)",
    silver: "var(--formant-color-primary-silver)",
    white: "var(--formant-color-primary-white)",
};

export const highlights: Record<string, string> = {
    blue: "var(--formant-color-highlights-blue)",
    royalBlue: "var(--formant-color-highlights-royal-blue)",
    purple: "var(--formant-color-highlights-purple)",
    blueIce: "var(--formant-color-highlights-blue-ice)",
    offWhite: "var(--formant-color-highlights-off-white)",
};

export const severityLevels: Record<string, string> = {
    green: "var(--formant-color-severity-levels-green)",
    royalBlue: "var(--formant-color-severity-levels-royal-blue)",
    purple: "var(--formant-color-severity-levels-purple)",
    orange: "var(--formant-color-severity-levels-orange)",
    red: "var(--formant-color-severity-levels-red)",
};
